<template>
  <v-navigation-drawer
    v-model="drawer"
    app right hide-overlay temporary
    width="400"
  >
    <v-card flat tile>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="drawer = false"><v-icon>keyboard_tab</v-icon></v-btn>
        <v-toolbar-title>{{ $t('Notifications') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-badge color="red" :value="countUnread > 0" class="titleDISABLED">
          <template v-slot:badge>
            <span class="caption">{{ countUnread }}</span>
          </template>
          <v-tooltip bottom>
            <span slot="activator">{{ items.length }}</span>
            {{ countUnread }} {{ $t("unread out of") }} {{ items.length }}
          </v-tooltip>
        </v-badge>
        <v-spacer></v-spacer>
        <v-menu offset-y origin="top right" transition="scale-transition" :close-on-content-click="false">
          <v-tooltip bottom slot="activator">
            <v-btn slot="activator" icon><v-icon>{{ filter.length === Object.keys(events).length ? 'filter_alt' : 'filter_alt_off' }}</v-icon></v-btn>
            {{ $t("Filter") }}
          </v-tooltip>
          <v-card>
            <v-card-text class="pa-2">
              <v-btn-toggle multiple mandatory v-model="filter" class="elevation-0 transparent">
                <template v-for="(evt, key, idx) in events">
                  <v-divider vertical v-if="idx > 0"></v-divider>
                  <v-tooltip bottom :key="key">
                    <v-btn slot="activator" flat :value="key" :class="filter.includes(key) ? 'primary--text' : ''" dark>
                      <v-icon>{{ evt.icon }}</v-icon>
                    </v-btn>
                    <span>{{ $t(key) }}</span>
                  </v-tooltip>
                </template>
              </v-btn-toggle>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-tooltip bottom>
          <v-btn slot="activator" icon @click="remove()"><v-icon>delete</v-icon></v-btn>
          {{ $t("Clear all") }}
        </v-tooltip>
      </v-toolbar>

      <v-card-text class="pa-2">
        <v-container grid-list-xs class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-list three-line dense class="multi-line">
                <template v-for="(item, index) in filteredItems">
                  <v-divider :inset="!!item.unread" :class="!item.unread ? 'white' : ''" :key="index" v-if="index > 0"></v-divider>

                  <v-list-tile
                    :key="item.index"
                    :to="item.link"
                    :href="item.href"
                    @click="item.click"
                    ripple avatar
                    class="py-1"
                    :class="item.unread ? '' : 'blue-grey lighten-5'"
                  >
                    <v-list-tile-avatar :color="!item.unread ? 'blue lighten-4' : 'blue lighten-5'">
                      <v-tooltip bottom>
                        <v-icon medium slot="activator" :color="!item.unread ? 'white' : 'blue darken-1'">{{ item.icon }}</v-icon>
                        {{ $t(item.event) }}
                      </v-tooltip>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title slot="activator"
                        class="font-weight-bold blue--text"
                        :class="item.unread ? 'text--darken-2' : 'text--lighten-3'"
                      >{{ item.title }}</v-list-tile-title>

                      <template v-if="item.event == 'SHIPMENT_DELIVERY_FAILURE'">
                        <v-list-tile-sub-title class="text--primary text--lighten-5">
                          <span v-if="item.data.description" v-html="item.data.description"></span>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="mt-1">
                          <template v-if="item.data.state">
                            <v-tooltip bottom>
                              <v-icon size="14" slot="activator" color="blue-grey lighten-2" style="vertical-align: baseline" class="mr-1">{{ stateIcon(item.data.state) }}</v-icon>
                              {{ $t('ShipmentRoutingState.' + item.data.state) }}
                            </v-tooltip>
                            <span>{{ $t('ShipmentRoutingState.' + item.data.state) }}</span><br/>
                          </template>
                          <span><v-icon small color="grey" class="mr-1">star</v-icon>{{ item.data.manifest }}</span><br/>
                          <span v-if="item.data.station"><v-icon small color="grey" class="mr-1">place</v-icon>{{ item.data.station }}</span><!-- place | pin_drop -->
                        </v-list-tile-sub-title>
                      </template>

                      <v-list-tile-sub-title v-else-if="item.event == 'SHIPMENT_CHANGE_PRICE'" class="text--primary">
                        <span><v-icon small color="grey" class="mr-1">star</v-icon>{{ item.data.manifest }}</span>
                        <span v-if="item.data.price_old">: {{ showAmount(item.data.price_old) }}</span>
                        <span v-if="item.data.price_new"> &rarr;
                          <span class="blue--text text--darken-1">{{ showAmount(item.data.price_new) }}</span>
                          <span v-if="!item.data.price_old"> ({{ $t("new price") }})</span>
                        </span>
                      </v-list-tile-sub-title>

                      <v-list-tile-sub-title v-else-if="item.event == 'POD_DOWNLOAD'" class="text--primary">
                        <span>{{ $t('attached.to') }} {{ $t('ENTITY.' + item.data.entity) }} </span>
                        <span><v-icon small color="grey" class="mr-1">star</v-icon>{{ item.data.id }}</span><br/>
                        <a :href="item.data.link" download>{{ item.data.filename }}</a>
                      </v-list-tile-sub-title>

                      <v-list-tile-sub-title v-else-if="item.event == 'NEWS_ITEM'" class="text--primary">
                        <div v-html="item.data.text" class="news-item"></div>
                      </v-list-tile-sub-title>

                      <v-list-tile-sub-title v-else class="text--primary"><div v-html="item.data.text"></div></v-list-tile-sub-title>

                      <v-list-tile-sub-title class="mt-2">
                        <v-icon small color="blue-grey lighten-3">access_time</v-icon>
                        <span class="ml-1 blue-grey--text text--lighten-3">{{ smartDate(item.timestamp) }}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action class="align-self-center" style="min-width: 24px;">
                      <v-tooltip bottom v-if="item.link">
                        <v-btn icon small slot="activator" :to="item.link" class="mb-2">
                          <v-icon small color="blue-grey lighten-2">{{ item.data.state ? 'search' : 'edit' }}</v-icon>
                        </v-btn>
                        {{ item.data.state ? $t('Track') : $t('Edit') }}
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn icon small slot="activator" @click.stop="remove(index)">
                          <v-icon small color="blue-grey lighten-2">delete</v-icon>
                        </v-btn>
                        {{ $t("Clear") }}
                      </v-tooltip>
                    </v-list-tile-action>
                  </v-list-tile>

                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <news-item v-model="selectedItem" @show="selectedItem = null"></news-item>
  </v-navigation-drawer>

</template>

<script>
import { notifications } from "../resources";
import { save, read, clear } from "../storage";
import { STORE_KEY_NOTIFICATIONS_SINCE, STORE_KEY_NOTIFICATIONS_ITEMS } from "../constants";
import { getStateIcon, showAmount } from "../components/util";
import NewsItem from "../components/NewsItem.vue";

const TIMER_INTERVAL_MINS = 30;
const CHECK_DAYS_BACK = 2;

export default {
  name: "notifications",
  props: {
    value: { type: Boolean, default: false }
  },
  components: {
    NewsItem
  },
  data() {
    return {
      drawer: this.value,
      timer: null,
      stored: JSON.parse(read(STORE_KEY_NOTIFICATIONS_ITEMS)) || [],
      events: {
        "NEWS_ITEM": {// Новини {title, text}
          icon:  "message",
          click: item => this.showNewsItem(item),
          title: result => result.data.title,
        },
        "SHIPMENT_DELIVERY_FAILURE": {// Неуспешен разнос {shipment (id), manifest, state (code), date, description, station}
          icon:  "location_off",
          link:  result => { return { name: "track_id", params: { id: result.data.manifest }} },
          title: result => this.$t( result.event ),
        },
        "SHIPMENT_CHANGE_PRICE": {// Промяна в цената {shipment (id), manifest, price_old, price_new (money objects)}
          icon:  "monetization_on",
          link:  result => { return { name: "request", params: { id: result.data.shipment }} },
          title: result => this.$t( result.event ),
        },
        "POD_DOWNLOAD": {// {invoice (id), link, date}
          icon:  "attach_email",// attach_email
          href:  result => result.data.link,
          title: result => this.$t( result.event )
        },
      },
      items: [],
      selectedItem: { data: {}},
      filter: [
        "NEWS_ITEM",
        "SHIPMENT_DELIVERY_FAILURE",
        "SHIPMENT_CHANGE_PRICE",
        "POD_DOWNLOAD"
      ],
      showAmount,
      sound: new Audio("./static/chat-notify.wav"),// wav|mp3|ogg
    }
  },

  computed: {
    countUnread() {// New, Unread
      return this.items.filter(item => item.unread).length;
    },
    noItems() {
      return this.items.length === 0;
    },
    filteredItems() {
      return this.items.filter(elem => this.filter.includes(elem.event));
    }
  },

  created() {
    this.notifyJob();
    this.timer = window.setInterval( this.notifyJob.bind(this), 1000 * 60 * TIMER_INTERVAL_MINS );
  },

  destroyed() {
    if (this.timer)
      window.clearInterval( this.timer );
    clear(STORE_KEY_NOTIFICATIONS_SINCE);
  },

  watch: {
    value(val) {
      this.drawer = val;
      if (val === false) {
        // Mark all read
        this.items.forEach(item => {
          item.unread = false;
          let stored = this.stored.find(elem => elem.id === item.id);
          if (stored) {
            stored.read = true;
          }
          else {
            this.stored.unshift({ id: item.id, read: true });
          }
        });
        save(STORE_KEY_NOTIFICATIONS_ITEMS, JSON.stringify(this.stored));
      }
    },
    drawer(val) {
      this.$emit("input", val);
    },
    items(val) {
      this.$emit("itemsCount", val.length);
    },
    countUnread(val, oldval) {
      if (val > 0 && val > oldval)
        this.notifySound();
      this.$emit("unreadCount", val);
    },
  },

  methods: {
    stateIcon(e) {// e = state.code, not as should be = {}
      let stateObj = { code: e };
      return getStateIcon(stateObj).stateIcon;
    },

    /** Parse date from timestamp. @param {int} dateOrTime 1=date_only; 2=time_only; null=full */
    smartDate(timestamp, dateOrTime) {
      if (!timestamp) return "";
      let d = new Date( timestamp ),
          year  = d.getFullYear(),
          month = ("0" + (d.getMonth()+1) ).slice(-2),
          day   = ("0" + d.getDate() ).slice(-2),
          hour  = ("0" + d.getHours() ).slice(-2),
          min   = ("0" + d.getMinutes() ).slice(-2);

      let time = `${hour}:${min}`,
          date = `${year}-${month}-${day}`;

      if (dateOrTime && dateOrTime == 1)
        return date;
      else if (dateOrTime && dateOrTime == 2)
        return time;
      else {
        let now = new Date();
        if (d.getDate() == now.getDate())
          date = this.$t("Today");
        else if (d.getDate() == now.getDate()-1)
          date = this.$t("Yesterday");

        return `${date} ${time}`;
      }
    },
    notifySound() {
      if (this.sound) {
        this.sound.volume = (document.hasFocus() ? 0.3 : 1);
        this.sound.play().catch(e => console.log("Cannot play notify sound", e));
      }
    },
    remove(index) {
      if (index !== undefined) {
        let id = this.items[index].id;
        let stored = this.stored.find(elem => elem.id === id);
        if (stored) {
          stored.deleted = true;
        }
        else {
          this.stored.unshift({ id: id, read: true, deleted: true });
        }
        //this.stored.push(this.items[index].id);
        this.items.splice( index, 1 );
      }
      else {
        this.items.forEach(item => {
          let stored = this.stored.find(elem => elem.id === item.id);
          if (stored) {
            stored.deleted = true;
          }
          else {
            this.stored.unshift({ id: item.id, read: true, deleted: true });
          }
        });
        //this.stored.push(...this.items.map(item => item.id));
        this.items = [];
      }
      save(STORE_KEY_NOTIFICATIONS_ITEMS, JSON.stringify(this.stored));
      event.preventDefault();
    },

    notifyJob() {
      //console.log("notifyJob, storedItems=", read( STORE_KEY_NOTIFICATIONS_ITEMS ));
      if (this.noItems) {
        clear(STORE_KEY_NOTIFICATIONS_SINCE);
      }
      const since = parseInt(
        read( STORE_KEY_NOTIFICATIONS_SINCE ) ||
        new Date().setDate(new Date().getDate() - CHECK_DAYS_BACK)
      );
      const until = new Date().valueOf();

      notifications.get({since, until}).then(response => {
        if (response.body.result) {
          this.notifyParseResult(response.body.result, since, until);
        }
        save(STORE_KEY_NOTIFICATIONS_SINCE, until);
      }).catch(error => {
        // console.log("Exception caught on Notify request", new Date(until));
      });
    },
    notifyParseResult(response, since, until) {
      let thisvue = this;
      response.sort((a, b) => {
        return a.stamp - b.stamp;
      });
      response.forEach(res => {
        const stored = this.stored.find(elem => elem.id === res.stamp);
        if (stored && stored.deleted)
          return;
        let event = thisvue.events[res.event];//thisvue.events.find(e => e.event === res.event);
        let item = {
          id: res.stamp,
          since: since,
          until: until,
          unread: !(stored && stored.read),//true,
          timestamp: res.stamp,
          event: res.event,
          //
          icon: event.icon,
          link: event.link ? event.link(res) : null,
          href: event.href ? event.href(res) : null,
          // click: () => event.click ? event.click(res) : null,
          title: event.title(res),
          data: res.data
        };
        item.click = () => (event.click ? event.click(item) : null),
        thisvue.items.unshift(item);
      });
    },
    showNewsItem(item) {
      this.selectedItem = {
        ...item,
        smartDate: this.smartDate(item.timestamp)
      };
    },
    eventInfo(item) {
      return this.events[item.event] || {};
    }
  }
}
</script>
<style>
.v-list.multi-line .v-list__tile {
  height: auto !important;
}
.v-list.multi-line .v-list__tile .v-list__tile__avatar {
  align-self: flex-start;
  -ms-flex-item-align: start;
  margin-top: 8px;
}
.v-list.multi-line .v-list__tile .v-list__tile__content .v-list__tile__sub-title {
  line-height: 140%;
}
</style>
<style scoped>
.news-item {
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 5.2rem;
}
</style>
